import React, { useState, useEffect, useMemo, useContext } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  capabilitiesByActiveBySortKey,
  commoditiesByActiveBySortKey,
  setupDataByCognitoIdByStatus,
} from "../graphql/queries";
import {
  createArea,
  createPaymentTerm,
  createReloadYard,
  createReloadYardCommodity,
  createReloadYardCapability,
  createSetupData,
  createUser,
  createZone,
  updateSetupData,
} from "../graphql/mutations";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import useToast from "../utils/useToast";
import { logError } from "../utils/appUtils";

import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  useMediaQuery,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  Hidden,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  RadioGroup,
  Radio,
  TextField,
  Checkbox,
  Backdrop,
} from "@material-ui/core";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import RefreshIcon from "@material-ui/icons/Refresh";
import ThemeToggleIcon from "@material-ui/icons/Brightness6";

import { useThemeState } from "../ThemeStateProvider";
import Setup from "./Setup";
import SetupContext from "./context";
import {
  ERROR_MSG,
  NewCustomerStatus,
  ReloadYardStatus,
  SORTKEY_BUFFER,
  UserStatus,
  UserType,
  workdays,
} from "../utils/constants";
import { getEnv } from "../utils/appUtils";

import { createAccessorialCharges } from "../managerApp/resources/services/ServiceUtils";

import "./CardSectionStyles.css";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { endOfMonth, addDays, startOfDay, endOfDay } from "date-fns";
import StripeLogo from "../images/stripe-payment.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  themeButton: {
    marginRight: theme.spacing(3),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    margin: "auto",
    paddingTop: theme.spacing(1),
  },
  site: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(4),
  },
  link: {
    display: "flex",
    justifyContent: "center",
    color: "inherit",
    textDecoration: "inherit",
  },
  backdrop: {
    zIndex: 90001,
  },
  containerMobile: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(16),
    marginRight: theme.spacing(16),
  },
  setupButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
  },
  card: {
    marginTop: theme.spacing(1),
  },
  cardTitle: {
    display: "flex",
    justifyContent: "center",
  },
  formControl: {
    margin: theme.spacing(3),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
}));

const logout = () => {
  window.location.href = `${window.location.origin}/logout`;
};

const NewYard = () => {
  const [setupMode, setSetupMode] = useState();
  const [newYardData, setNewYardData] = useState();
  const [areaMap, setAreaMap] = useState({});
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const welcomeMsg = "Thank you for choosing transloads.co";
  const showToast = useToast();
  const svgLogo = "/logo_transloads_white.svg";
  const { togglePalette } = useThemeState();

  useEffect(() => {
    getNewYardData();
  }, []);

  const getNewYardData = async () => {
    try {
      debugger;
      const { cognitoId } = window.appUser;
      let response = await API.graphql(
        graphqlOperation(setupDataByCognitoIdByStatus, { cognitoId })
      );
      let data = response.data.setupDataByCognitoIdByStatus.items[0];

      if (!data) {
        const input = {
          status: NewCustomerStatus.NEW,
          submitDate: new Date(),
          cognitoId,
        };
        response = await API.graphql(
          graphqlOperation(createSetupData, { input })
        );
        data = response.data.createSetupData;
      }
      setNewYardData(data);
      debugger;
    } catch (err) {
      showToast();
      logError("site:NewYard:getNewYardData", err, false);
    }
  };

  const completeSetup = (activeStep, state) => {
    debugger;
    try {
      handleSave(activeStep, state, NewCustomerStatus.PENDING_APPROVAL);
      handleCancel();
    } catch (err) {
      showToast();
      logError("site:NewYard:completeSetup", err, false);
    }
  };

  const handleSave = async (activeStep, state, status) => {
    debugger;
    state.activeStep = activeStep;
    state.yardInfo.userEmail = window.appUser?.email;
    const input = {
      ...newYardData,
      setupData: JSON.stringify(state),
      firstName: state.yardInfo.firstName,
      lastName: state.yardInfo.lastName,
      businessName: state.yardInfo.businessName,
    };
    if (status && status === NewCustomerStatus.PENDING_APPROVAL) {
      input.status = status;
      input.submitDate = new Date();
    }

    return await doHandleSave(input);
  };

  const doHandleSave = async (input) => {
    delete input.validators;
    delete input.updatedAt;
    delete input.owner;
    debugger;
    const response = await API.graphql(
      graphqlOperation(updateSetupData, { input })
    );
    setNewYardData(response.data.updateSetupData);
    debugger;
    return JSON.parse(response.data.updateSetupData.setupData);
  };

  const handleCancel = () => {
    setSetupMode(false);
  };

  const validate = () => {
    if (!newYardData.groups) {
      showToast("Invalid setup data");
      return false;
    }
    debugger;

    return true;
  };

  const createYard = async () => {
    /*
            validations:
                - groups exists in newYardData
                - userreloadYardByName cognitoId is unique
                - reloadyard name is unique
        */

    try {
      const setupData = JSON.parse(newYardData.setupData);
      const isValid = validate();
      if (!isValid) return false;
      // if (true) return true;
      debugger;
      const reloadYard = await doCreateYard(setupData);

      const { areas, zones, paymentTerms } = setupData;
      await createAreas(reloadYard.id, areas);
      await createZones(reloadYard.id, zones, areas);
      await doCreateUser(setupData, reloadYard.id);
      await doCreateCommodities(reloadYard.id);
      await doCreateCapabilities(reloadYard.id);
      await createPaymentTerms(reloadYard.id, paymentTerms);
      await createAccessorialCharges(reloadYard);
    } catch (err) {
      logError("site:NewYard:createYard", err, false);
      return false;
    }
    return true;
  };

  const doCreateCommodities = async (reloadYardId) => {
    debugger;
    const response = await API.graphql(
      graphqlOperation(commoditiesByActiveBySortKey, { active: "true" })
    );
    const commodities = response.data.commoditiesByActiveBySortKey.items;
    const results = await Promise.allSettled(
      commodities.map((itm) => {
        const input = {
          reloadYardId,
          commodityId: itm.id,
          groups: newYardData.groups,
          active: itm.name === "Other",
          verified: true,
          units: itm.defaultUnits,
          sortKey: itm.sortKey,
        };
        return API.graphql(
          graphqlOperation(createReloadYardCommodity, { input })
        );
      })
    );

    const resError = results.find((itm) => itm.status === "rejected");
    if (resError) {
      logError("NewYard:doCreateCommodities", resError, false);
    }
  };

  const doCreateCapabilities = async (reloadYardId) => {
    const response = await API.graphql(
      graphqlOperation(capabilitiesByActiveBySortKey, { active: "true" })
    );
    const capabilities = response.data.capabilitiesByActiveBySortKey.items;
    debugger;
    const results = await Promise.allSettled(
      capabilities.map((itm) => {
        const input = {
          reloadYardId,
          capabilityId: itm.id,
          groups: newYardData.groups,
          active: false,
          verified: true,
        };
        return API.graphql(
          graphqlOperation(createReloadYardCapability, { input })
        );
      })
    );
    debugger;
    const resError = results.find((itm) => itm.status === "rejected");
    if (resError) {
      logError("NewYard:doCreateCapabilities", resError, false);
    }
  };

  const createPaymentTerms = async (reloadYardId, paymentTerms) => {
    debugger;
    const termList = paymentTerms.map((itm, idx) => {
      const input = {
        groups: newYardData.groups,
        reloadYardId,
        code: itm.code,
        name: itm.name,
        type: itm.type,
        dueDays: itm.dueDays,
        sortKey: SORTKEY_BUFFER + idx,
      };
      return API.graphql(graphqlOperation(createPaymentTerm, { input }));
    });
    const response = await Promise.allSettled(termList);
    response.forEach((itm) => {
      if (itm.status === "rejected") {
        logError("NewYard:createPaymentTerms", itm.reason, false);
      }
    });
  };

  const createAreas = async (reloadYardId, areas) => {
    const areaList = areas.map((itm, idx) => {
      const input = {
        active: true,
        groups: newYardData.groups,
        reloadYardId,
        name: itm.name,
        prefix: itm.prefix,
        color: itm.color,
        sortKey: idx + 1,
        areaType: itm.areaType,
      };
      return API.graphql(graphqlOperation(createArea, { input }));
    });
    const promiseResults = await Promise.allSettled(areaList);
    debugger;
    promiseResults.forEach((itm) => {
      if (itm.status === "fulfilled") {
        const value = itm.value;
        const newArea = value.data.createArea;
        areaMap[newArea.name] = newArea;
        setAreaMap(areaMap);
      }
    });
  };

  const createZones = async (reloadYardId, zones, areas) => {
    const origAreaIdsMap = {};
    areas.forEach((itm) => {
      origAreaIdsMap[itm.id] = areaMap[itm.name];
    });

    const zonePromiseList = zones.map((itm, idx) => {
      const areaId = origAreaIdsMap[itm.areaId].id;
      debugger;
      const input = {
        active: true,
        groups: newYardData.groups,
        reloadYardId,
        name: itm.name,
        prefix: itm.prefix,
        color: itm.color,
        sortKey: idx + 1,
        zoneType: itm.zoneType,
        areaId,
      };
      return API.graphql(graphqlOperation(createZone, { input }));
    });
    const promiseResults = await Promise.allSettled(zonePromiseList);
    debugger;
    const dbZones = promiseResults.map((itm) => {
      if (itm.status === "fulfilled") {
        return itm.value.data.createZone;
      }
      return null;
    });
    return dbZones;
  };

  const doCreateYard = async (setupData) => {
    debugger;
    const input = {
      groups: newYardData.groups,
      active: true,
      status: ReloadYardStatus.TRIALING,
      name: setupData.yardInfo.businessName,
      phone: setupData.yardInfo.phoneNumber,
      fax: setupData.yardInfo.faxNumber,
      website: setupData.yardInfo.website,
      street: setupData.yardInfo.street,
      city: setupData.yardInfo.city,
      email: setupData.yardInfo.email.toLowerCase(),
      state: setupData.yardInfo.state.toUpperCase(),
      zipCode: setupData.yardInfo.zip,
      timeZone: setupData.yardInfo.timeZone,
      country: setupData.yardInfo.country,
      lotCapacity: setupData.yardInfo.lotCapacityAcres,
      trackCapacity: setupData.yardInfo.trackCapacity,
      servingCarrier: setupData.yardInfo.servingCarrier,
      warehouseCapacity: setupData.yardInfo.warehouseCapacity,
      railHighway: setupData.yardInfo.accessToRailHighway,
      invoiceNumberPrefix: setupData.yardInfo.businessName
        .replace(/\s/g, "")
        .substring(0, 3)
        .toUpperCase(),
      invoiceCounter: 1000,
      bolCounter: 1000,
      receiptCounter: 1000,
      taxRates: setupData.yardInfo.taxRates,
      subscription: {
        customerId: setupData.subscription.customerId,
        subscriptionId: setupData.subscription.subscriptionId,
        priceId: setupData.subscription.priceId,
        status: "active",
      },
      schedule: {
        workdays,
        holidays: [],
        minNoticeHours: 24,
        maxDaysIntoFuture: 60,
      },
      tosAccept: setupData.tosAccept,
    };
    let response = await API.graphql(
      graphqlOperation(createReloadYard, { input })
    );
    debugger;
    return response.data.createReloadYard;
  };

  const doCreateUser = async (setupData, reloadYardId) => {
    debugger;
    const input = {
      groups: newYardData.groups,
      active: true,
      status: UserStatus.APPROVED,
      cognitoId: window.appUser?.cognitoId,
      type: UserType.MANAGER,
      firstName: setupData.yardInfo.firstName,
      lastName: setupData.yardInfo.lastName,
      fullName: `${setupData.yardInfo.firstName} ${setupData.yardInfo.lastName}`,
      email: window.appUser?.email.toLowerCase(),
      phone: setupData.yardInfo.userPhone,
      reloadYardId: reloadYardId,
    };
    const response = await API.graphql(graphqlOperation(createUser, { input }));
    debugger;
    return response.data.createUser;
  };

  return (
    <div className={classes.root}>
      <AppBar color="primary" position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.logo}>
            <img src={svgLogo} alt="transloads.co logo" height="30px" />
          </div>
          <IconButton
            color="inherit"
            aria-label="toggle theme"
            className={classes.themeButton}
            onClick={togglePalette}
          >
            <ThemeToggleIcon />
          </IconButton>
          <Link to="/" className={classes.link}>
            <Button
              color="inherit"
              size="large"
              onClick={logout}
              startIcon={<ExitToAppIcon />}
            >
              Logout
            </Button>
          </Link>
        </Toolbar>
      </AppBar>
      <div className={isXSmall ? classes.containerMobile : classes.container}>
        {!setupMode ? (
          <Card>
            <CardHeader
              title={<div className={classes.cardTitle}>{welcomeMsg}</div>}
            />
            <CardContent>
              {newYardData?.status === NewCustomerStatus.NEW ? (
                <NewSetupContent
                  newYardData={newYardData}
                  setNewYardData={setNewYardData}
                  setSetupMode={setSetupMode}
                  classes={classes}
                />
              ) : newYardData?.status === NewCustomerStatus.PENDING_APPROVAL ? (
                <PendingSetupApprovalContent classes={classes} />
              ) : newYardData?.status === NewCustomerStatus.APPROVED ? (
                <ApprovedSetupContent
                  createYard={createYard}
                  classes={classes}
                  newYardData={newYardData}
                  doHandleSave={doHandleSave}
                />
              ) : (
                <div className={classes.progress}>
                  <CircularProgress color="inherit" />
                </div>
              )}
            </CardContent>
          </Card>
        ) : (
          <Setup
            setupData={newYardData?.setupData}
            completeSetup={completeSetup}
            handleCancel={handleCancel}
            handleSave={handleSave}
          />
        )}
      </div>
    </div>
  );
};

const NewSetupContent = ({
  newYardData,
  setNewYardData,
  setSetupMode,
  classes,
}) => {
  const [open, setOpen] = useState(false);
  const initState = useContext(SetupContext);

  const handleClick = () => {
    if (newYardData?.firstName) setSetupMode(true);
    else setOpen(true);
  };

  const handleTosAccept = async () => {
    const tosAccept = {
      acceptTimeStamp: new Date(),
      cognitoId: newYardData.cognitoId,
      email: window.appUser?.email,
      userAgent: window.navigator.userAgent,
      ip: "",
    };
    debugger;

    try {
      let response = await API.post("transREST", "/tos-accept");

      if (response.err) {
        // get error message from body or default to response statusText
        logError(
          "site:NewYard:NewSetupContent:handleTosAccept:transREST",
          response.err,
          false
        );

        try {
          response = await fetch("https://api.ipify.org?format=json");
          debugger;
          const data = await response.json();
          if (!response.ok) {
            // get error message from body or default to response statusText
            const ferror = (data && data.message) || response.statusText;
            logError(
              "site:NewYard:NewSetupContent:handleTosAccept:ferror",
              ferror,
              false
            );
          }
          tosAccept.ip = data.ip;
        } catch (error) {
          logError(
            "site:NewYard:NewSetupContent:handleTosAccept:tetch",
            response.err,
            false
          );
        }
      } else {
        tosAccept.acceptTimeStamp = response.tosSignature.acceptTimeStamp;
        tosAccept.ip = response.tosSignature.ip;
      }

      newYardData.setupData = JSON.stringify({
        ...initState,
        tosAccept: tosAccept,
      });
      setNewYardData(newYardData);
    } catch (error) {
      debugger;
      logError("site:NewYard:NewSetupContent:handleTosAccept", error, false);
    }

    setSetupMode(true);
    setOpen(false);
  };

  const handleClose = (_, reason) => {
    if (reason !== "backdropClick") setOpen(false);
  };

  return (
    <>
      <Typography align="center" gutterBottom>
        In just a few quick steps we'll setup your Yard Management System.
      </Typography>
      <Typography align="center" gutterBottom>
        If you need help setting up your transload, please contact our Customer
        Success team at
      </Typography>
      <Typography align="center" gutterBottom>
        1-877-TRANSLOAD (872-6756)
      </Typography>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h6">The fine print</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography gutterBottom>
              By clicking "Accept" you agree to and accept our&nbsp;
              <a
                href="https://www.transloads.co/terms-of-service"
                target="blank"
                rel="noopener"
              >
                Terms of Service
              </a>{" "}
              and&nbsp;
              <a
                href="https://www.transloads.co/privacy-policy"
                target="blank"
                rel="noopener"
              >
                Privacy Policy
              </a>
              .
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Go back
          </Button>
          <Button onClick={handleTosAccept} color="primary" autoFocus>
            Accept
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.setupButton}>
        <Button
          size="large"
          variant="contained"
          color="secondary"
          onClick={handleClick}
        >
          {newYardData?.firstName ? "Resume setup" : "Start setup"}
        </Button>
      </div>
    </>
  );
};

const PendingSetupApprovalContent = ({ classes }) => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div style={{ width: "50%", margin: "0 auto 0 auto" }}>
      <Typography align="center" gutterBottom>
        Your registration has been sent to our Customer Success team for review.
      </Typography>
      <Typography align="center" gutterBottom>
        To ensure highest level of service and information accuracy, one of our
        transload experts will shortly reach out to you to confirm your
        submission.
      </Typography>
      <Typography gutterBottom variant="h4" align="center">
        Pending review...
      </Typography>
      <div className={classes.setupButton}>
        <Button
          size="large"
          variant="contained"
          color="secondary"
          startIcon={<RefreshIcon />}
          onClick={reloadPage}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

const BillingPanel = ({
  setupData,
  newYardData,
  paid,
  setPaid,
  doHandleSave,
  classes,
}) => {
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");
  const [disabled, setDisabled] = useState(true);

  const [price, setPrice] = useState(setupData.subscription?.priceList[0]?.id);
  const [name, setName] = useState(
    `${setupData.yardInfo.firstName} ${setupData.yardInfo.lastName}`
  );

  const stripe = useStripe();
  const elements = useElements();
  debugger;

  const cardStyle = {
    style: {
      base: {
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  const displayError = (message) => {
    setError(message ? message : null);
    setPaid(false);
    setProcessing(false);
  };

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : null);
  };

  const createPaymentMethod = async (card) => {
    // Set up payment method for recurring usage
    const customerId = setupData.subscription.customerId;

    debugger;
    const result = await stripe.createPaymentMethod({
      type: "card",
      card,
      billing_details: {
        name: name,
      },
    });

    debugger;
    if (result.error) {
      // throw result.error;
      displayError(`Payment failed: ${result.error.message}`);
    } else {
      await createSubscription({
        customerId: customerId,
        paymentMethodId: result.paymentMethod.id,
        priceId: price,
      });
    }
  };

  const createSubscription = ({ customerId, paymentMethodId, priceId }) => {
    const trialDate = endOfDay(
      addDays(new Date(), setupData?.subscription?.trialPeriod || 0)
    );
    const billingDate = startOfDay(addDays(endOfMonth(new Date(trialDate)), 1));
    debugger;

    return (
      API.post("transREST", "/stripe-create-subscription", {
        body: {
          customerId: customerId,
          paymentMethodId: paymentMethodId,
          priceId: priceId,
          trial_end:
            setupData.subscription.trialPeriod > 0
              ? Math.ceil(trialDate.getTime() / 1000)
              : "now",
          billing_cycle_anchor: Math.ceil(billingDate.getTime() / 1000),
          proration_behavior: "create_prorations", // 'none',
        },
      })
        // If the card is declined, display an error to the user.
        .then((result) => {
          debugger;
          if (result.error) {
            // The card had an error when trying to attach it to a customer.
            // throw result.error;
            displayError(`Payment failed: ${result.error.message}`);
          }
          return result;
        })
        // Normalize the result to contain the object returned by Stripe.
        // Add the additional details we need.
        .then((result) => {
          return {
            paymentMethodId: paymentMethodId,
            priceId: priceId,
            subscription: result,
          };
        })
        // Some payment methods require a customer to be on session
        // to complete the payment process. Check the status of the
        // payment intent to handle these actions.
        .then(handlePaymentThatRequiresCustomerAction)
        // If attaching this card to a Customer object succeeds,
        // but attempts to charge the customer fail, you
        // get a requires_payment_method error.
        .then(handleRequiresPaymentMethod)
        // No more actions required. Provision your service for the user.
        .then(onSubscriptionComplete)
        .catch((error) => {
          debugger;
          logError("site:NewYard:createSubscription", error, false);
          throw error;
        })
    );
  };

  const handlePaymentThatRequiresCustomerAction = ({
    subscription,
    invoice,
    priceId,
    paymentMethodId,
    isRetry,
  }) => {
    debugger;
    if (
      subscription &&
      (subscription.status === "active" || subscription.status === "trialing")
    ) {
      // Subscription is active, no customer actions required.
      return { subscription, priceId, paymentMethodId };
    }

    // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
    // If it's a retry, the payment intent will be on the invoice itself.
    let paymentIntent = invoice
      ? invoice.payment_intent
      : subscription.latest_invoice.payment_intent;

    if (
      paymentIntent.status === "requires_action" ||
      (isRetry === true && paymentIntent.status === "requires_payment_method")
    ) {
      return stripe
        .confirmCardPayment(paymentIntent.client_secret, {
          payment_method: paymentMethodId,
        })
        .then((result) => {
          if (result.error) {
            // Start code flow to handle updating the payment details.
            // Display error message in your UI.
            // The card was declined (i.e. insufficient funds, card has expired, etc).
            // throw result;
            setError(`Payment failed: ${result.error.message}`);
          } else {
            if (result.paymentIntent.status === "succeeded") {
              // Show a success message to your customer.
              return {
                priceId: priceId,
                subscription: subscription,
                invoice: invoice,
                paymentMethodId: paymentMethodId,
              };
            }
          }
        })
        .catch((error) => {
          debugger;
          // throw error.error;
          displayError(`Payment failed: ${error.error.message}`);
        });
    } else {
      // No customer action needed.
      return { subscription, priceId, paymentMethodId };
    }
  };

  const handleRequiresPaymentMethod = ({
    subscription,
    paymentMethodId,
    priceId,
  }) => {
    debugger;
    if (
      subscription.status === "active" ||
      subscription.status === "trialing"
    ) {
      // subscription is active, no customer actions required.

      return { subscription, priceId, paymentMethodId };
    } else if (
      subscription.latest_invoice.payment_intent.status ===
      "requires_payment_method"
    ) {
      // Using localStorage to manage the state of the retry here,
      // feel free to replace with what you prefer.
      // Store the latest invoice ID and status.
      // localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
      // localStorage.setItem(
      //     'latestInvoicePaymentIntentStatus',
      //     subscription.latest_invoice.payment_intent.status
      // );
      // throw { message: 'Your card was declined.' };
      displayError(`Payment failed: Your card was declined.`);
    } else {
      debugger;
      return { subscription, priceId, paymentMethodId };
    }
  };

  const onSubscriptionComplete = async (result) => {
    // Payment was successful.
    debugger;
    if (
      result.subscription.status === "active" ||
      result.subscription.status === "trialing"
    ) {
      // Change your UI to show a success message to your customer.
      // Call your backend to grant access to your service based on
      // `result.subscription.items.data[0].price.product` the customer subscribed to.
      setupData.subscription.subscriptionId = result.subscription.id;
      setupData.subscription.priceId = result.priceId;
      const input = { ...newYardData, setupData: JSON.stringify(setupData) };
      await doHandleSave(input);

      setError(null);
      setProcessing(false);
      setPaid(true);
    } else {
      debugger;
      // incomplete.
    }
  };

  const handlePaySubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);
    setError(null);

    try {
      await createPaymentMethod(elements.getElement(CardElement));

      debugger;
    } catch (error) {
      debugger;
      setError(ERROR_MSG);
      setPaid(false);
      setProcessing(false);
      logError("site:NewYard:handlePaySubmit", error, false);
    }
  };

  return (
    <form id="payment-form" onSubmit={handlePaySubmit}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Typography align="center" gutterBottom>
            Beep, beep, you've been approved!
          </Typography>
          <Typography align="center" gutterBottom>
            Now, let's setup your subscription...
          </Typography>
        </Grid>
        <Hidden mdDown>
          {" "}
          <Grid item xs={false} lg={1}>
            {" "}
          </Grid>{" "}
        </Hidden>
        <Grid item xs={12} md={6} lg={5}>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">
              Select the perfect plan for you...
            </FormLabel>
            {setupData.subscription.trialPeriod > 0 ? (
              <FormControlLabel
                control={<Checkbox name="trial" color="primary" checked />}
                label={`Free ${setupData.subscription.trialPeriod}-day trial`}
              />
            ) : null}
            <FormControlLabel
              control={<Checkbox name="setupFee" color="primary" checked />}
              label={`$0 Setup Fees`}
            />
            <RadioGroup
              aria-label="price-plan"
              name="price-plan"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            >
              {setupData.subscription?.priceList &&
                setupData.subscription.priceList.map((price) => (
                  <FormControlLabel
                    control={<Radio />}
                    value={price.id}
                    label={price.nickname}
                  />
                ))}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={5} className={classes.formControl}>
          <img
            src={StripeLogo}
            alt="Secure billing with Stripe"
            height="40px"
          />
          <TextField
            id="name"
            label="Name on Card"
            variant="outlined"
            margin="dense"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText=" "
          />
          <CardElement
            id="card-element"
            options={cardStyle}
            // options={options}
            onChange={handleChange}
          />
          {/* Show any error that happens when processing the payment */}
          <FormHelperText margin="dense" error={error !== null}>
            {" "}
            {error}{" "}
          </FormHelperText>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: "16px" }}
            disabled={processing || disabled || paid}
          >
            {processing ? (
              <CircularProgress
                color="inherit"
                size={18}
                thickness={3}
                className={classes.leftIcon}
              />
            ) : null}
            Start Free Trial
          </Button>
        </Grid>
        <Hidden mdDown>
          {" "}
          <Grid item xs={false} lg={1}>
            {" "}
          </Grid>{" "}
        </Hidden>
      </Grid>
    </form>
  );
};

const ApprovedSetupContent = ({
  createYard,
  classes,
  newYardData,
  doHandleSave,
}) => {
  const [showDialog, setShowDialog] = useState();
  const [error, setError] = useState();
  const [header, setHeader] = useState("Setup completed sucessully");
  const [message, setMessage] = useState();
  const [showProgress, setShowProgress] = useState();
  const setupData = JSON.parse(newYardData.setupData);
  const [paid, setPaid] = useState(setupData?.subscription?.subscriptionId);

  useEffect(() => {
    setPaid(setupData?.subscription?.subscriptionId);
  }, [setupData]);

  const doCreateYard = async () => {
    setShowProgress(true);
    const status = await createYard();
    debugger;
    setShowProgress(false);
    if (!status) {
      setError(true);
      setHeader("Error");
      setMessage(ERROR_MSG);
      setShowDialog(true);
    } else window.location.reload();
  };

  const handleClose = (_, reason) => {
    if (reason !== "backdropClick") {
      setShowDialog(false);
      if (!error) window.location.reload();
    }
  };

  // Make sure to call `loadStripe` outside of a component’s render to avoid
  // recreating the `Stripe` object on every render. Use Publishable Key.
  const stripePromise = useMemo(
    () =>
      loadStripe(
        getEnv() === "prod"
          ? "pk_live_51Iv8spLjcHh8hNWxt5bOA46FiBEoq9xFrPNMGpduU3sX2D5AcAMTAv7DOv59hb2Tu8h8GEXJfiHXcghxzDuPrATO00IRm2UZN8"
          : "pk_test_51ItK8SBuW3L4WKIAtEgx0hvyNGa1GNJFdvjLWu0hpTKROJDmFAMtS4CpZDdDh8yamP0hYVvo9jW9V4Ge9MfiPHWJ00s1171Abt"
      ),
    []
  );

  return showProgress ? (
    <Backdrop className={classes.backdrop} open={showProgress}>
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <>
      {!paid ? (
        <Elements stripe={stripePromise}>
          <BillingPanel
            setupData={setupData}
            newYardData={newYardData}
            paid={paid}
            setPaid={setPaid}
            doHandleSave={doHandleSave}
            classes={classes}
          />
        </Elements>
      ) : null}
      {paid ? (
        <>
          <Typography align="center" gutterBottom>
            Your payment processed successfully. Thank you!
          </Typography>
          <Typography align="center" gutterBottom>
            Click "COMPLETE SETUP" to proceed to the Manager Portal.
          </Typography>
          <Typography align="center" gutterBottom>
            If at any time you require assistance, please call our Customer
            Success team at 1-877-TRANSLOAD.
          </Typography>
          <Dialog open={showDialog} onClose={handleClose}>
            <DialogTitle id="alert-dialog-title">
              <Typography variant="h6" color={error ? "error" : ""}>
                {header}
              </Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Typography gutterBottom color={error ? "error" : ""}>
                  {message}
                </Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={handleClose} color="primary">
                close
              </Button>
            </DialogActions>
          </Dialog>
          <div className={classes.setupButton}>
            <Button
              size="large"
              variant="contained"
              color="secondary"
              disabled={showProgress}
              onClick={doCreateYard}
            >
              Complete Setup
            </Button>
          </div>
        </>
      ) : null}
    </>
  );
};

export { NewYard };
